module.exports = __webpack_public_path__ + "img/user.bbd6ff0a.png";